export default {
	keys: [],
	drafts: [],
	deleted: [],
	tags: [],
	platformTags: [],
	categories: [],
	languages: [],
	users: [],
	activeKey: { id: 0, text: "" },
	activeTranslationKey: null,
	activeTag: null,
	authKey: "",
	roles: [],
  translationStatus: false
}
